import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import type { PalantirIcon } from './icon.type';
import PalantirIcons from './icon.type';

@Component({
  selector: 'palantir-icon',
  standalone: true,
  imports: [],
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class PalantirIconComponent {
  public domSanitizer = inject(DomSanitizer);

  public name = input.required<PalantirIcon | undefined>();

  public sanitizedIcon = computed(this.computeSanitizedIcon.bind(this));

  public PalantirIcons = PalantirIcons;

  private computeSanitizedIcon() {
    const name = this.name();
    if (!name || !PalantirIcons[name]) {
      return '';
    }

    return this.domSanitizer.bypassSecurityTrustHtml(PalantirIcons[name]);
  }
}
